import React from 'react';


const Error = ({ error }) => (
  <div className="row">
    <div className="col-md-6 pull-left">
      <div className="has-error">
        <label className="help-block">
          {error}
        </label>
      </div>
      <br />
    </div>
  </div>
);

export default Error;


// WEBPACK FOOTER //
// ./app/javascript/components/card_details/components/UI/Error.js